/**
 * 500 / Internal Server Error
 * TODO - make it prettier
 */
import React from 'react'

const InternalServerError = () => (
  <div style={{ margin: '1em' }}>
    <h3>Oops. An internal server error has occurred.</h3>
    <p>Try again a little later or submit an IVAN ticket if urgent.</p>
  </div>
)

export default InternalServerError
